export default "__VITE_ASSET__BziTgMPD__"